import { apiSlice } from "../../api/ApiService";
import { getHeadersFromRedux } from "../../utility/functions/common-functions";

const getCelebrationListApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCelebrationList: builder.query({
      query: (value: {
        patientProfileId: number;
        preferredLanguage: string;
        patientCaseId: number;
      }) => {
        const headers = getHeadersFromRedux();
        headers["X-Language"] = value.preferredLanguage;
        return {
          url: `/api/v1/Patient/${value.patientProfileId}/${value.patientCaseId}/visual-celebration`,
          method: "GET",
          headers,
        };
      },
      providesTags: (result, error, arg) => [{ type: "VisualCelebration" }],
    }),
  }),
  overrideExisting: false,
});

export const { useGetCelebrationListQuery } = getCelebrationListApi;
export default getCelebrationListApi;
